import {
    ChatMessageDeletedEventPayloadSchema,
    ChatMessageSchema,
} from "@albertine/types/openapi/concierge-v1";
import { reconcileChatOutboxWithSentMessage } from "../-data/chatOutbox";
import {
    type ConciergeChatEventName,
    ConciergeChatEventSchema,
} from "../-data/conciergeSseConnection";
import { assertNever } from "./chatErrors";
import {
    type ChatThreadPage,
    removeThreadMessage,
    upsertThreadMessage,
} from "./threadCache";

export function applyConciergeEvent(
    eventType: ConciergeChatEventName,
    value: unknown,
    updateThread: (
        update: (page: ChatThreadPage | undefined) => ChatThreadPage,
    ) => void,
) {
    const event = ConciergeChatEventSchema.parse(value);
    switch (eventType) {
        case "message-sent": {
            const message = ChatMessageSchema.parse(event.data);
            updateThread((page) => upsertThreadMessage(page, message));
            reconcileChatOutboxWithSentMessage(message);
            break;
        }
        case "message-edited": {
            const message = ChatMessageSchema.parse(event.data);
            updateThread((page) => upsertThreadMessage(page, message));
            break;
        }
        case "message-deleted": {
            const deleted = ChatMessageDeletedEventPayloadSchema.parse(event.data);
            updateThread((page) => removeThreadMessage(page, deleted.id));
            break;
        }
        default:
            assertNever(eventType);
    }
}
